export const GET_MATCH_HIGHLIGHTS = "GET_MATCH_HIGHLIGHTS";